@if (data.typeError.toString() === 'INFO') {
  <div class="snackbar snackbar-info">
    <div class="icon-circle icon-info">
      <mat-icon>check</mat-icon>
    </div>
    <span class="message">{{ data.menssage }}</span>
  </div>
}

@if (data.typeError.toString() === 'ERROR') {
  <div class="snackbar snackbar-error">
    <div class="icon-circle icon-error">
      <mat-icon>close</mat-icon>
    </div>
    <span class="message">{{ data.menssage }}</span>
  </div>
}

@if (data.typeError.toString() === 'WARNING') {
  <div class="snackbar snackbar-warn">
    <div class="icon-circle icon-warn">
      <mat-icon>warning</mat-icon>
    </div>
    <span class="message">{{ data.menssage }}</span>
  </div>
}
